import React from "react";
import { useMeta } from "../../context/MetaContext";
import { numberToWords, fmtInr } from "../../utils/salarySlipUtils";

const S = {
    wrap: {
        fontFamily: "'Plus Jakarta Sans',system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
        fontSize: "11px",
        color: "#111",
        background: "#fff",
        minWidth: "800px",
    },
    hdr: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "8px 24px 6px",
        borderBottom: "2px solid #1e3a8a",
    },
    hdrLogo: { display: "flex", alignItems: "center", gap: "14px" },
    coName: { fontSize: "18px", fontWeight: 800, color: "#1e3a8a", letterSpacing: "0.5px" },
    coAddr: { fontSize: "10px", color: "#555", marginTop: "3px", lineHeight: 1.6 },
    slipTitle: {
        background: "#1e3a8a",
        color: "#fff",
        fontSize: "20px",
        fontWeight: 900,
        letterSpacing: "3px",
        padding: "6px 20px",
        textAlign: "center",
    },
    slipMonth: { fontSize: "15px", fontWeight: 700, color: "#1e3a8a", textAlign: "center", marginTop: "6px" },
    slipPeriod: { fontSize: "10px", color: "#666", textAlign: "center", marginTop: "2px" },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        border: "1px solid #d1d5db",
        borderTop: "none",
    },
    infoCol: { borderRight: "1px solid #d1d5db" },
    infoColLast: {},
    infoHead: {
        background: "#1e3a8a",
        color: "#fff",
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "1px",
        textTransform: "uppercase",
        padding: "6px 14px",
    },
    infoRow: {
        display: "flex",
        gap: "4px",
        padding: "5px 14px",
        borderBottom: "1px solid #f3f4f6",
        fontSize: "10.5px",
    },
    infoLabel: { color: "#555", minWidth: "108px", flexShrink: 0 },
    infoColon: { color: "#888" },
    infoVal: { fontWeight: 600, color: "#111", wordBreak: "break-word" },
    edGrid: { display: "grid", gridTemplateColumns: "1fr 1fr" },
    edHead: {
        display: "flex",
        justifyContent: "space-between",
        padding: "7px 16px",
        fontSize: "10px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "1px",
        borderBottom: "1px solid #e5e7eb",
        background: "#f8fafc",
    },
    edRow: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 16px",
        borderBottom: "1px solid #f3f4f6",
        fontSize: "10.5px",
    },
    edTotal: {
        display: "flex",
        justifyContent: "space-between",
        padding: "9px 16px",
        fontSize: "11px",
        fontWeight: 800,
        borderTop: "2px solid #1e3a8a",
    },
    netBar: { display: "flex", background: "#1e3a8a", color: "#fff", alignItems: "center" },
    netLabel: {
        padding: "10px 20px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "1px",
        textTransform: "uppercase",
        borderRight: "1px solid rgba(255,255,255,0.2)",
    },
    netAmount: {
        flex: 1,
        textAlign: "right",
        padding: "10px 24px",
        fontSize: "24px",
        fontWeight: 900,
        letterSpacing: "1px",
    },
    netWords: {
        textAlign: "center",
        padding: "7px",
        fontSize: "10px",
        fontStyle: "italic",
        color: "#444",
        background: "#f8fafc",
        borderBottom: "1px solid #e5e7eb",
    },
    btmGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        border: "1px solid #d1d5db",
        borderTop: "none",
    },
    btmCol: { padding: "12px 16px", borderRight: "1px solid #d1d5db" },
    btmColLast: { padding: "12px 16px" },
    btmHead: {
        fontSize: "10px",
        fontWeight: 700,
        color: "#1e3a8a",
        textTransform: "uppercase",
        letterSpacing: "1px",
        marginBottom: "8px",
        paddingBottom: "5px",
        borderBottom: "1px solid #e5e7eb",
    },
    btmRow: {
        display: "flex",
        gap: "4px",
        fontSize: "10px",
        padding: "3px 0",
        color: "#555",
        alignItems: "flex-start",
    },
    btmLabel: { minWidth: "120px", flexShrink: 0 },
    btmVal: { fontWeight: 600, color: "#111" },
    ftr: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        padding: "14px 24px",
        background: "#f9fafb",
        borderTop: "1px solid #e5e7eb",
    },
    ftrNote: { fontSize: "9px", color: "#777", lineHeight: 1.8, maxWidth: "55%" },
    ftrSig: { textAlign: "right" },
    ftrSigImgWrap: {
        marginLeft: "auto",
        marginBottom: "8px",
        background: "transparent",
        padding: "0",
        display: "block",
        width: "fit-content",
    },
    ftrSigImg: {
        display: "block",
        height: "52px",
        width: "auto",
        maxWidth: "280px",
        objectFit: "contain",
        mixBlendMode: "multiply",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
    },
    ftrSigLine: { borderTop: "1.5px solid #333", width: "170px", marginBottom: "5px", marginLeft: "auto" },
    ftrSigName: { fontSize: "13px", fontStyle: "italic", fontFamily: "'Plus Jakarta Sans',system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif", color: "#1e3a8a" },
    ftrSigTitle: { fontSize: "9px", color: "#666", marginTop: "2px" },
};

const InfoRow = ({ label, value }) => (
    <div style={S.infoRow}>
        <span style={S.infoLabel}>{label}</span>
        <span style={S.infoColon}>:</span>
        <span style={S.infoVal}>{value}</span>
    </div>
);

const formatDisplayName = (value, fallback = "N/A", splitWorkWords = false) => {
    let text = String(value || "").trim();
    if (!text) return fallback;
    if (splitWorkWords) {
        text = text.replace(
            /\b([A-Za-z]{2,})(team|lead|manager|developer|designer|engineer|executive|associate|intern|admin)\b/gi,
            "$1 $2",
        );
    }
    return text
        .split(/\s+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};

const formatUppercase = (value, fallback = "N/A") => {
    const text = String(value || "").trim();
    return text ? text.toUpperCase() : fallback;
};

const SalarySlipDocument = ({
    employee,
    period,
    approvedExpenses = [],
    signatureSrc,
    pageBreakAfter = false,
    slipConfig = {},
    manualOverrides = {},
    companySettings = {},
}) => {
    const { logoUrl } = useMeta();

    const {
        showEmployeeDetails = true,
        showPeriodDetails = true,
        showPaymentDetails = true,
        showEarnings = true,
        showDeductions = true,
        showAttendanceSummary = true,
        showPaymentInfo = true,
    } = slipConfig;

    const {
        payMonth,
        payPeriod,
        payDate,
        workDays,
        lopDays,
        leaveTakenDays,
        paidDays,
        gross,
        basic,
        hra,
        daAmount = 0,
        hraAmount = 0,
        otherAllowancesAmount = 0,
        otAmount = 0,
        bonusAmount = 0,
        pfAmount = 0,
        esiAmount = 0,
        profTaxAmount = 0,
        stayAllowance = 0,
        totalExpenses,
        totalDed,
        net,
    } = period;

    const employeeName = manualOverrides.employeeName || formatDisplayName(employee.name);
    const designation = manualOverrides.designation || formatDisplayName(employee.designation || employee.role, "Associate", true);
    const department = manualOverrides.department || formatDisplayName(employee.team, "N/A", true);
    const panNumber = manualOverrides.panNumber || formatUppercase(employee.panNumber);
    const employeeId = manualOverrides.employeeId || employee.employeeId || "N/A";
    const uanNumber = manualOverrides.uanNumber || employee.uanNumber || "N/A";

    const displayPayMonth = manualOverrides.payMonth || payMonth;
    const displayPayPeriod = manualOverrides.payPeriod || payPeriod;
    const displayWorkDays = manualOverrides.workDays || workDays;
    const displayPaidDays = manualOverrides.paidDays || paidDays;
    const displayLeaveTaken = manualOverrides.leaveTakenDays || (leaveTakenDays ?? lopDays);
    const displayLopDays = manualOverrides.lopDays || lopDays;

    const displayBankName = manualOverrides.bankName || employee.bankDetails?.bankName || "N/A";
    const displayAccountNo = manualOverrides.accountNo || (employee.bankDetails?.accountNumber ? `**** **** ${employee.bankDetails.accountNumber.slice(-4)}` : "N/A");
    const displayIfscCode = manualOverrides.ifscCode || employee.bankDetails?.ifscCode || "N/A";

    let finalPaymentDate = new Date(period.periodEnd);
    const payType = companySettings?.paymentDateType || "offset";

    if (payType === "offset") {
        const offsetDays = parseInt(companySettings?.paymentDateOffset || 0, 10);
        finalPaymentDate.setDate(finalPaymentDate.getDate() + 1 + offsetDays);
    } else if (payType === "month_end") {
        finalPaymentDate = new Date(period.periodEnd.getFullYear(), period.periodEnd.getMonth() + 1, 0);
    } else if (payType === "month_start") {
        finalPaymentDate = new Date(period.periodEnd.getFullYear(), period.periodEnd.getMonth() + 1, 1);
    } else if (payType === "custom_date") {
        const customDay = parseInt(companySettings?.paymentCustomDate || 1, 10);
        let m = period.periodEnd.getMonth();
        let y = period.periodEnd.getFullYear();
        if (customDay <= period.periodEnd.getDate()) {
            m += 1;
        }
        finalPaymentDate = new Date(y, m, customDay);
    }

    const computedPayDateStr = finalPaymentDate.getDate() + " " + finalPaymentDate.toLocaleString("en-IN", { month: "long" }) + " " + finalPaymentDate.getFullYear();
    const displayPayDate = manualOverrides.payDate || (companySettings?.paymentDateType ? computedPayDateStr : payDate);

    return (
        <div
            className={pageBreakAfter ? "slip-page" : ""}
            style={{ marginBottom: pageBreakAfter ? "32px" : 0 }}
        >
            <div className="slip" style={S.wrap}>
                <div style={S.hdr}>
                    <div style={S.hdrLogo}>
                        <img src={companySettings.logoUrl || logoUrl || "/logo.png"} alt="Logo" style={{ height: `${companySettings.logoSize || 46}px`, maxWidth: "180px", objectFit: "contain" }} />
                        <div>
                            <div style={S.coName}>{companySettings.companyName || "AVIATRICKS AERO LABS PRIVATE LIMITED"}</div>
                            <div style={S.coAddr}>
                                {companySettings.address ? (
                                    companySettings.address.split('\n').map((line, i) => <React.Fragment key={i}>{line}<br/></React.Fragment>)
                                ) : (
                                    <>
                                        Manikampalayam, Koothampoondi, Namakkal - 637202, Tamil Nadu
                                        <br />
                                        Phone: +91 9965319525 | Email: hello@aviatricks.com
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div style={{ minWidth: "200px", textAlign: "right" }}>
                        <div style={S.slipMonth}>{displayPayMonth}</div>
                        <div style={S.slipPeriod}>(For the period {displayPayPeriod})</div>
                    </div>
                </div>

                <div style={S.infoGrid}>
                    {showEmployeeDetails && (
                        <div style={S.infoCol}>
                            <div style={S.infoHead}>Employee Details</div>
                            <InfoRow label="Employee Name" value={employeeName} />
                            <InfoRow label="Employee ID" value={employeeId} />
                            <InfoRow label="Designation" value={designation} />
                            <InfoRow label="Department" value={department} />
                            <InfoRow
                                label="Date of Joining"
                                value={
                                    manualOverrides.joiningDate || (employee.joiningDate
                                        ? new Date(employee.joiningDate).toLocaleDateString("en-IN", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                          })
                                        : "N/A")
                                }
                            />
                            <InfoRow label="PAN" value={panNumber} />
                            <InfoRow label="Account No." value={displayAccountNo} />
                            <InfoRow label="UAN No." value={uanNumber} />
                        </div>
                    )}
                    {showPeriodDetails && (
                        <div style={S.infoCol}>
                            <div style={S.infoHead}>Salary Period Details</div>
                            <InfoRow label="Pay Month" value={displayPayMonth} />
                            <InfoRow label="Pay Period" value={displayPayPeriod} />
                            <InfoRow label="Working Days" value={displayWorkDays} />
                            <InfoRow label="Paid Days" value={displayPaidDays} />
                            <InfoRow label="Leave Taken" value={displayLeaveTaken} />
                            <InfoRow label="Loss of Pay (LOP)" value={displayLopDays} />
                        </div>
                    )}
                    {showPaymentDetails && (
                        <div style={S.infoColLast}>
                            <div style={S.infoHead}>Payment Details</div>
                            <InfoRow label="Payment Mode" value={manualOverrides.paymentMode || "Bank Transfer"} />
                            <InfoRow label="Bank Name" value={displayBankName} />
                            <InfoRow label="Account No." value={displayAccountNo} />
                            <InfoRow label="IFSC Code" value={displayIfscCode} />
                            <InfoRow label="Payment Date" value={displayPayDate} />
                        </div>
                    )}
                </div>

                <div style={{ ...S.edGrid, border: "1px solid #d1d5db", borderTop: "none" }}>
                    <div style={{ borderRight: "1px solid #d1d5db" }}>
                        <div style={{ ...S.edHead, color: "#16a34a" }}>
                            <span>Earnings</span>
                            <span>Amount (₹)</span>
                        </div>
                        {showEarnings && (
                            <>
                                {basic > 0 && (
                                    <div style={S.edRow}>
                                        <span>Basic Salary</span>
                                        <span>{fmtInr(basic)}</span>
                                    </div>
                                )}
                                {daAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Dearness Allowance (DA)</span>
                                        <span>{fmtInr(daAmount)}</span>
                                    </div>
                                )}
                                {hraAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>House Rent Allowance (HRA)</span>
                                        <span>{fmtInr(hraAmount)}</span>
                                    </div>
                                )}
                                {otherAllowancesAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Other Allowances</span>
                                        <span>{fmtInr(otherAllowancesAmount)}</span>
                                    </div>
                                )}
                                {otAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Overtime Allowance</span>
                                        <span>{fmtInr(otAmount)}</span>
                                    </div>
                                )}
                                {bonusAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Bonus</span>
                                        <span>{fmtInr(bonusAmount)}</span>
                                    </div>
                                )}
                                {approvedExpenses.map((exp, i) => (
                                    <div key={i} style={{ ...S.edRow, background: "#f0fdf4" }}>
                                        <span>Expense: {exp.title}</span>
                                        <span style={{ color: "#16a34a", fontWeight: 600 }}>{fmtInr(exp.amount)}</span>
                                    </div>
                                ))}
                            </>
                        )}
                        <div style={{ ...S.edTotal, color: "#16a34a", borderTopColor: "#16a34a" }}>
                            <span>Total Earnings</span>
                            <span>{fmtInr(gross + totalExpenses)}</span>
                        </div>
                    </div>
                    <div>
                        <div style={{ ...S.edHead, color: "#dc2626" }}>
                            <span>Deductions</span>
                            <span>Amount (₹)</span>
                        </div>
                        {showDeductions && (
                            <>
                                {pfAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Provident Fund (PF)</span>
                                        <span style={{ color: "#dc2626", fontWeight: 600 }}>{fmtInr(pfAmount)}</span>
                                    </div>
                                )}
                                {esiAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>ESI</span>
                                        <span style={{ color: "#dc2626", fontWeight: 600 }}>{fmtInr(esiAmount)}</span>
                                    </div>
                                )}
                                {profTaxAmount > 0 && (
                                    <div style={S.edRow}>
                                        <span>Professional Tax</span>
                                        <span style={{ color: "#dc2626", fontWeight: 600 }}>{fmtInr(profTaxAmount)}</span>
                                    </div>
                                )}
                                {period.lopDed > 0 && (
                                    <div style={S.edRow}>
                                        <span>Loss of Pay (LOP)</span>
                                        <span style={{ color: "#dc2626", fontWeight: 600 }}>{fmtInr(period.lopDed)}</span>
                                    </div>
                                )}
                                {stayAllowance > 0 && (
                                    <div style={S.edRow}>
                                        <span>Stay Allowance</span>
                                        <span style={{ color: "#dc2626", fontWeight: 600 }}>{fmtInr(stayAllowance)}</span>
                                    </div>
                                )}
                            </>
                        )}
                        <div style={{ ...S.edTotal, borderTopColor: "#dc2626", color: "#dc2626" }}>
                            <span>Total Deductions</span>
                            <span>{fmtInr(totalDed)}</span>
                        </div>
                    </div>
                </div>

                <div style={S.netBar}>
                    <div style={S.netLabel}>Net Salary Payable (₹)</div>
                    <div style={S.netAmount}>₹ {net.toLocaleString("en-IN")}.00</div>
                </div>
                <div style={{ ...S.netWords, border: "1px solid #d1d5db", borderTop: "none" }}>
                    ( {numberToWords(net)} )
                </div>

                <div style={S.btmGrid}>
                    {showAttendanceSummary && (
                        <div style={S.btmCol}>
                            <div style={S.btmHead}>Attendance Summary</div>
                            {[
                                ["Total Working Days", displayWorkDays],
                                ["Loss of Pay (LOP) Days", displayLopDays],
                                ["Paid Days", displayPaidDays],
                            ].map(([l, v], i) => (
                                <div key={i} style={S.btmRow}>
                                    <span style={S.btmLabel}>{l}</span>
                                    <span>:</span>
                                    <span
                                        style={{
                                            ...S.btmVal,
                                            color: i >= 2 && lopDays > 0 ? "#dc2626" : "#111",
                                        }}
                                    >
                                        {v}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                    {showPaymentInfo && (
                        <div style={S.btmColLast}>
                            <div style={S.btmHead}>Payment Info</div>
                            {[
                                ["Gross Salary", `₹ ${fmtInr(gross)}`],
                                ...(totalExpenses > 0
                                    ? [["Expense Reimbursement", `₹ ${fmtInr(totalExpenses)}`]]
                                    : []),
                                ["Total Deductions", `₹ ${fmtInr(totalDed)}`],
                                ["Net Payable", `₹ ${net.toLocaleString("en-IN")}.00`],
                            ].map(([l, v], i) => (
                                <div key={i} style={S.btmRow}>
                                    <span style={S.btmLabel}>{l}</span>
                                    <span>:</span>
                                    <span
                                        style={{
                                            ...S.btmVal,
                                            color: l === "Expense Reimbursement" ? "#16a34a" : "#111",
                                        }}
                                    >
                                        {v}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div style={S.ftr}>
                    <div style={S.ftrNote}>
                        <strong style={{ color: "#555" }}>Note:</strong>
                        <br />
                        1. This is a system generated payslip for your records.
                        <br />
                        2. Please contact HR Department at hr@aviatricks.in for any queries.
                    </div>
                    <div style={S.ftrSig}>
                        <div style={S.ftrSigImgWrap}>
                            <img src={companySettings.signatureUrl || signatureSrc} alt="Authorised signature" style={S.ftrSigImg} />
                        </div>
                        <div style={S.ftrSigLine} />
                        <div style={S.ftrSigName}>{companySettings.authorizedSignatory || "Authorised Signatory"}</div>
                        <div style={S.ftrSigTitle}>(HR Manager, Aviatricks Aero Labs)</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalarySlipDocument;
